import { CollectionEntity } from "@busy-human/gearbox";
export var Integration;
(function (Integration) {
    Integration.Default = () => ({ type: "" });
    ;
    Integration.DataSchema = {
        zoll: {
            type: null,
            APIVersion: "string",
            Vendor: "string",
            CADID: "string",
            CADSerial: "string",
            DispatchID: "string",
            DispatchSerial: "string",
            isTest: "boolean"
        },
        EMResource: {
            type: null,
            username: "string",
            password: 'encryptedString'
        },
        Cradlepoint: {
            type: null,
            CRAPIAppId: "string",
            CRAPIAppKey: "string",
            ECMAPIAppId: "string",
            ECMAPIAppKey: "string"
        },
        Outerlink: {
            type: null,
            username: "string",
            password: "encryptedString"
        }
    };
    class CollectionClass extends CollectionEntity {
        relationships;
        defaults = Integration.Default;
        async getIntegration(integration) {
            const doc = await this.docRef(integration).get();
            if (!doc.exists)
                return null;
            return doc.data();
        }
        async setIntegration(integration, data) {
            await this.docEntity(integration).set(data);
        }
        async getAllIntegrations() {
            const tmp = {};
            const res = await this.all().fetch();
            for (const intInstance of res) {
                const data = { ...intInstance.data() };
                delete data.$id;
                tmp[intInstance.$id] = data;
            }
            return tmp;
        }
        async deleteIntegration(integration) {
            await this.deleteDoc(integration);
        }
    }
    Integration.CollectionClass = CollectionClass;
})(Integration || (Integration = {}));
//# sourceMappingURL=index.js.map